// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatisticsTab_container__LaQ\\+c {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
}
 
.StatisticsTab_SelectBox__bT4Jx {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));
  gap: 16px;
}

.StatisticsTab_topSection__BnJgb {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.StatisticsTab_card__2dTXp {
  flex: 1 1;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.StatisticsTab_cardHeader__op7M8 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 10px;
}

.StatisticsTab_cardStats__6CPkt {
  display: flex;
  justify-content: space-between;
}

.StatisticsTab_cardStats__6CPkt p {
  font-size: 13px;
  color: #666;
}

.StatisticsTab_cardStats__6CPkt h3 {
  margin-top: 4px;
  font-size: 18px;
}

.StatisticsTab_icon__Cpngu {
  font-size: 18px;
}

.StatisticsTab_blue__e898T { color: #1a73e8; }
.StatisticsTab_orange__SsuMh { color: #f57c00; }
.StatisticsTab_green__0BKF\\+ { color: #2e7d32; }
.StatisticsTab_purple__AXODy { color: #6a1b9a; }

.StatisticsTab_chartContainer__DWnV1 {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  position: relative;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.StatisticsTab_noData__49l6q {
  text-align: center;
  font-size: 14px;
  color: #888;
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
}

.StatisticsTab_sideStats__gyw62 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.StatisticsTab_smallCard__ObTRs {
  flex: 1 1 220px;
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.StatisticsTab_smallCard__ObTRs p {
  font-size: 14px;
  color: #555;
}

.StatisticsTab_smallCard__ObTRs h3 {
  margin-top: 3px;
  font-size: 16px;
}

.StatisticsTab_bottomSection__3j4cJ {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.StatisticsTab_tableBlock__Sqbcj {
  flex: 1 1;
  background: #f9f9f9;
  border-radius: 10px;
  padding: 10px;
}

.StatisticsTab_tableBlock__Sqbcj h4 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
}

th, td {
  padding: 10px;
  text-align: left;
  font-size: 14px;
}

.StatisticsTab_noDataText__6rLNx {
  text-align: center;
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AnalyticsPages/StatisticsTab.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAAQ,cAAc,EAAE;AACxB,+BAAU,cAAc,EAAE;AAC1B,+BAAS,cAAc,EAAE;AACzB,+BAAU,cAAc,EAAE;;AAE1B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-bottom: 20px;\n}\n \n.SelectBox {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 0.2fr));\n  gap: 16px;\n}\n\n.topSection {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.card {\n  flex: 1;\n  background: #fff;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.cardStats {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cardStats p {\n  font-size: 13px;\n  color: #666;\n}\n\n.cardStats h3 {\n  margin-top: 4px;\n  font-size: 18px;\n}\n\n.icon {\n  font-size: 18px;\n}\n\n.blue { color: #1a73e8; }\n.orange { color: #f57c00; }\n.green { color: #2e7d32; }\n.purple { color: #6a1b9a; }\n\n.chartContainer {\n  background: #fff;\n  border-radius: 10px;\n  padding: 10px;\n  position: relative;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.noData {\n  text-align: center;\n  font-size: 14px;\n  color: #888;\n  position: absolute;\n  bottom: 5px;\n  left: 0;\n  width: 100%;\n}\n\n.sideStats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.smallCard {\n  flex: 1 1 220px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.smallCard p {\n  font-size: 14px;\n  color: #555;\n}\n\n.smallCard h3 {\n  margin-top: 3px;\n  font-size: 16px;\n}\n\n.bottomSection {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.tableBlock {\n  flex: 1;\n  background: #f9f9f9;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.tableBlock h4 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  border-radius: 10px;\n}\n\nth, td {\n  padding: 10px;\n  text-align: left;\n  font-size: 14px;\n}\n\n.noDataText {\n  text-align: center;\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StatisticsTab_container__LaQ+c`,
	"SelectBox": `StatisticsTab_SelectBox__bT4Jx`,
	"topSection": `StatisticsTab_topSection__BnJgb`,
	"card": `StatisticsTab_card__2dTXp`,
	"cardHeader": `StatisticsTab_cardHeader__op7M8`,
	"cardStats": `StatisticsTab_cardStats__6CPkt`,
	"icon": `StatisticsTab_icon__Cpngu`,
	"blue": `StatisticsTab_blue__e898T`,
	"orange": `StatisticsTab_orange__SsuMh`,
	"green": `StatisticsTab_green__0BKF+`,
	"purple": `StatisticsTab_purple__AXODy`,
	"chartContainer": `StatisticsTab_chartContainer__DWnV1`,
	"noData": `StatisticsTab_noData__49l6q`,
	"sideStats": `StatisticsTab_sideStats__gyw62`,
	"smallCard": `StatisticsTab_smallCard__ObTRs`,
	"bottomSection": `StatisticsTab_bottomSection__3j4cJ`,
	"tableBlock": `StatisticsTab_tableBlock__Sqbcj`,
	"noDataText": `StatisticsTab_noDataText__6rLNx`
};
export default ___CSS_LOADER_EXPORT___;
